// extracted by mini-css-extract-plugin
export default {"image":"styles_image__cycyX","teamMember":"styles_teamMember__roHC1"};